import { render, staticRenderFns } from "./FieldHeading.vue?vue&type=template&id=15ad4da4&scoped=true&"
import script from "./FieldHeading.vue?vue&type=script&lang=js&"
export * from "./FieldHeading.vue?vue&type=script&lang=js&"
import style0 from "./FieldHeading.vue?vue&type=style&index=0&id=15ad4da4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad4da4",
  null
  
)

export default component.exports